import { combineReducers, Reducer } from '@reduxjs/toolkit';

import authReducer from 'features/auth/redux/slice';
import schoolReducer from 'features/school/redux/slice';
import alertReducer from 'features/alert/redux/slice';
import menuReducer from 'features/menu/redux/slice';
import headersReducer from 'features/headers/redux/slice';
import productsReducer from 'features/products/redux/slice';
import booksReducer from 'features/books/redux/slice';
import tipsReducer from 'features/tips/redux/slice';
import livesReducer from 'features/lives/redux/slice';
import teachersReducer from 'features/teachers/redux/slice';
import modulesReducer from 'features/modules/redux/slice';
import contentsReducer from 'features/contents/redux/slice';
import badgesReducer from 'features/badges/redux/slice';
import accountReducer from 'features/account/redux/slice';
import agreementsReducer from 'features/agreements/redux/slice';
import reportsReducer from 'features/reports/redux/slice';
import offersReducer from 'features/offers/redux/slice';
// import paymentsReducer from 'features/payments/redux/slice';
import recommendationsReducer from 'features/recommendations/redux/slice';
import examsReducer from 'features/exams/redux/slice';
import commentsReducer from 'features/comments/redux/slice';
import octadeskReducer from 'features/octadesk/redux/slice';
import dashboardReducer from 'features/dashboard-new/redux/slice';
import downloadsReducer from 'features/downloads/redux/slice';
import journeysReducer from 'features/journeys/redux/slice';
import searchReducer from 'features/search/redux/slice';
import scormReducer from 'features/scorm/redux/slice';
import educationalReducer from 'features/educational/redux/slice';

const reducers = (injectedReducers = {}): Reducer =>
  combineReducers({
    auth: authReducer,
    school: schoolReducer,
    alert: alertReducer,
    menu: menuReducer,
    headers: headersReducer,
    products: productsReducer,
    books: booksReducer,
    tips: tipsReducer,
    lives: livesReducer,
    teachers: teachersReducer,
    modules: modulesReducer,
    contents: contentsReducer,
    badges: badgesReducer,
    account: accountReducer,
    agreements: agreementsReducer,
    reports: reportsReducer,
    offers: offersReducer,
    // payments: paymentsReducer,
    recommendations: recommendationsReducer,
    exams: examsReducer,
    comments: commentsReducer,
    octadesk: octadeskReducer,
    dashboard: dashboardReducer,
    downloads: downloadsReducer,
    journeys: journeysReducer,
    search: searchReducer,
    scorm: scormReducer,
    educational: educationalReducer,
    ...injectedReducers,
  });

export default reducers;
